<div class="card">
	<div class="card-header bg-theme mb-0">
		<h5 class="card-title text-light mb-0">
			{{pagetitle}}
		</h5>
	</div>
	<div class="card-body py-0 px-1">
		<div class="table-responsive">
			<table *ngIf="dtOptions.pagingType" datatable [dtOptions]="dtOptions"
				class="table table-bordered table-hover">
				<thead>
					<tr class="table_head">
						<th style="width: 90% !important;">Vessel</th>
						<th style="width: 10% !important;">Action</th>
					</tr>
				</thead>
				<tbody *ngIf="dataList?.length !== 0">
					<tr *ngFor="let v of dataList;let i = index;">
						<td>{{ v.vesselName }}</td>
						<td>
							<a class="btn btn-xs btn-primary" matTooltip="Edit" [routerLink]="['/app/dashboard',v.Id]">
								<fa-icon [icon]="['fas', 'list-alt']"></fa-icon>
							</a>
						</td>
					</tr>
				</tbody>
				<tbody *ngIf="dataList?.length === 0">
					<tr>
						<td colspan="4" class="text-center">No data found!</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>